<script>
	import Checkbox from "./Checkbox.svelte";
	import { onDestroy } from 'svelte';
	let num1 = 0;
	let num2 = 0;
	let val = "";
	let startTime;
	let remain;
	let updateEvent;
	const nothing = () => {
		alert("そんなものはない");
	};

	const start = () => {
		setTimeout(() => {
			const calcContainer = document.getElementById("calc-container");
			num1 = getRandom(10000,99999);
			num2 = getRandom(10000,99999);
			startTime = new Date();
			calcContainer.classList.remove("hidden");
			updateEvent = setInterval(() => {
				if(remain === "0.000"){
					clearInterval(updateEvent);
					setTimeout(human(),10);
				}
				const rawRemain = 2 - (Date.now() - startTime) / 1000;
				remain = formatTime(rawRemain);
				if(rawRemain <= 0){
					remain = "0.000";
				}
			},10);
		},800);
	};

	const formatTime = (time) => {
		const ans = Math.round(time * 1000) /1000;
		return ans;
	};

	const confirm = () => {
		clearInterval(updateEvent);
		if(val === String(num1 * num2)){
			alert("あなたはもはや完全にロボットです。");
			location.href = "https://www.google.com/search?q=%E5%85%88%E8%A1%8C%E8%80%85&oq=%E5%85%88%E8%A1%8C%E8%80%85&aqs=chrome..69i57j0l9.1462j0j7&sourceid=chrome&ie=UTF-8";
			document.getElementById("calc-container").classList.add("hidden");
			return;
		}
		human();
	};

	const human = () => {
		alert("ユーアヒューマンだっ・・・・！");
		location.href = "https://www.google.com/search?q=%E4%BA%BA%E9%96%93+%E3%81%A8%E3%81%AF&oq=%E4%BA%BA%E9%96%93%E3%80%80%E3%81%A8%E3%81%AF&aqs=chrome..69i57j0j0i30l8.1652j0j7&sourceid=chrome&ie=UTF-8";
		document.getElementById("calc-container").classList.add("hidden");
	};

	/**
	 * 最小値～最大値の範囲で乱数を生成
	 * @param {*} min 最小値
	 * @param {*} max 最大値
	 */
	const getRandom = (min, max) => {
			return Math.floor(Math.random() * ((max + 1) - min)) + min;
	};

	onDestroy(() => {
		clearInterval(updateEvent);
		document.getElementById("calc-container").classList.add("hidden");
	});
</script>

<main class="container">
	<div class="robot-container">
		<div class="sub">
			<Checkbox change={start}></Checkbox>
			<div class="arrow-container">
				<img alt="arrow" src="./arrow.png" width="42px">
				<span class="cha">PUUARUCHA</span>
			</div>
		</div>
		<div class="privacy">
			<a href="#" on:click={nothing}>プライバシー</a>
			<span aria-hidden="true" role="presentation"> - </span>
			<a href="#" on:click={nothing}>利用規約</a>
		</div>
	</div>
	<div id="calc-container" class="calc-container hidden">
		<div class="panel">
			<div class="header">
				<h1>2秒で</h1>
				<span>計算してください。</span>
				<span>{remain}</span>
			</div>
			<div class="calc">
				<span>{num1 + " × " + num2}</span>
			</div>
			<hr>
			<div class="controller">
				<input class="answer" autocomplete="off" type="text" bind:value={val}><button class="btn-confirm" on:click="{confirm}">確認</button>
			</div>
		</div>
	</div>
</main>

<style>
	.container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
	}

	.robot-container {
		height: 74px;
		width: 300px;
		border: 1px solid #d3d3d3;
		background-color: #f9f9f9;
		color: black;

		display: flex;
		flex-direction: column;
		padding-left: 10px;
	}

	.sub {
		display: flex;
		padding-left: 10px;
	}

	.arrow-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		flex-grow: 1;
	}

	.cha {
		color: rgb(85,85,85);
		font-size: 8px;
	}

	.privacy {
		text-align: right;
		font-size: 8px;
		font-weight: 400px;
		color: rgb(85,85,85);
		padding-right: 14px;
	}

	.privacy a {
		color: rgb(85,85,85);
	}

	.calc-container {
		display: flex;
		justify-content: center;
		align-items: center;

		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2;

		background-color: white;
	}

	.panel {
		width: 95%;
		max-width: 400px;
		box-shadow: 5px 5px 5px rgba(128,128,128,0.5);
		padding: 5px;
	}

	.header {
		background-color: #4a90e2;
		color: white;
		padding: 15px;
	}
	.header > h1 {
		font-size: 36px;
		font-weight: bold;
		margin: 0;
	}

	.calc {
		font-size: 28px;
		font-weight: 600;
		text-align: center;
	}

	.controller {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.answer {
		flex-grow: 1;
		margin-right: 10px;
		text-align: right;
	}

	.btn-confirm {
		background-color: #4a90e2;
		color: white;
		border-width: 1px;
		padding:5px 20px;
	}

	.hidden {
		display: none;
	}
</style>